import styled from 'styled-components';
import { white } from '@bufferapp/ui/style/colors';

export const GiphyWrapper = styled.div`
  background: ${white};
  border-radius: 15px;
  height: 100%;
  margin-top: 140px;
`;

export const GiphyContentWrapper = styled.div`
  height: calc(100% - 180px);
  overflow-y: scroll;
  padding: 0 30px 50px 30px;
`;

export const SearchBarWrapper = styled.div`
  margin-bottom: 15px;
  border: 1px solid #ab50cb;

  @media and (min-width: 959px) {
    width: calc(100% - 160px);
  }
`;

export const SuggestionBarWrapper = styled.div`
  margin-bottom: 5px;

  @media and (min-width: 959px) {
    width: calc(100% - 160px);
  }
`;

export const AttributionMarkWrapper = styled.div`
  padding-top: 20px;
  padding-right: 3%;
  float: right;
  height: 20px;
`;
